import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-fee-structure',
  imports: [SharedModule],
  templateUrl: './delete-fee-structure.component.html',
  styleUrl: './delete-fee-structure.component.scss'
})
export class DeleteFeeStructureComponent {


  @Output() closeDialog = new EventEmitter<any>();
  @Input() academicYearData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: FeeService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete() {
    this.isLoading = true;

    const payload = {
      id: this.academicYearData.id,
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    }

    this.api.deleteFeeStructure(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Fee Structure deleted successfully' });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
        this.isLoading = false;
      }
    }
    );

  }

}

